import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import {
  HeaderEditorialMenuLinksModule,
  HeaderMetaNavModule,
  HeaderProductMenuLinksModule,
  HeaderUIUserModule
} from '@hdms/shared/page-frame/ui';
import {
  ButtonModule,
  HrModule,
  LeftCardModule,
  PreloaderModule,
  RibbonModule,
  SmartbarModule,
  SvgIconModule
} from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { ContactBodyModule } from '../header-contact/contact-body/contact-body.module';
import { ContactFooterModule } from '../header-contact/contact-footer/contact-footer.module';
import { ContactHeaderModule } from '../header-contact/contact-header/contact-header.module';
import { HeaderRegistrationButtonComponent } from '../header-registration/header-registration-button.component';
import { SelectCurrencyModule } from '../header-select/select-currency/select-currency.module';
import { SelectLanguageModule } from '../header-select/select-language/select-language.module';
import { HeaderUserAccountWrapperComponent } from '../header-user-account-wrapper/header-user-account-wrapper.component';
import { HeaderUserLogoutComponent } from '../header-user-logout/header-user-logout.component';
import { HeaderUserWrapperModule } from '../header-user-wrapper/header-user-wrapper.module';

import { BurgerMenuPrimaryContentComponent } from './burger-menu-primary-content/burger-menu-primary-content.component';
import { BurgerMenuSecondaryContentComponent } from './burger-menu-secondary-content/burger-menu-secondary-content.component';
import { BurgerMenuSecondaryFooterComponent } from './burger-menu-secondary-footer/burger-menu-secondary-footer.component';
import { BurgerMenuSecondaryHeaderComponent } from './burger-menu-secondary-header/burger-menu-secondary-header.component';
import { BurgerMenuWrapperComponent } from './burger-menu-wrapper/burger-menu-wrapper.component';

@NgModule({
  declarations: [
    BurgerMenuPrimaryContentComponent,
    BurgerMenuSecondaryContentComponent,
    BurgerMenuSecondaryHeaderComponent,
    BurgerMenuSecondaryFooterComponent,
    BurgerMenuWrapperComponent
  ],
  imports: [
    ButtonModule,
    CommonModule,
    ContactBodyModule,
    ContactHeaderModule,
    ContactFooterModule,
    HeaderMetaNavModule,
    HeaderProductMenuLinksModule,
    HeaderEditorialMenuLinksModule,
    HeaderUIUserModule,
    TranslationModule,
    LeftCardModule,
    RibbonModule,
    SmartbarModule,
    SvgIconModule,
    HrModule,
    SelectCurrencyModule,
    SelectLanguageModule,
    PreloaderModule,
    HeaderUserWrapperModule,
    HeaderUserAccountWrapperComponent,
    HeaderUserLogoutComponent,
    AnalyticsModule,
    HeaderRegistrationButtonComponent
  ],
  exports: [
    BurgerMenuPrimaryContentComponent,
    BurgerMenuSecondaryContentComponent,
    BurgerMenuSecondaryHeaderComponent,
    BurgerMenuWrapperComponent
  ]
})
export class HeaderBurgerMenuModule {}
